import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const SortUpIcon = createSvgIcon(
  <>
    <title>sort up</title>
    <g className="nc-icon-wrapper" fill="#222222">
      <g
        fill="none"
        fillRule="evenodd"
        id="_Icon-/-Others-/-sort-up-/-Black"
        stroke="none"
        strokeWidth="1"
      >
        <g id="sort-up" transform="translate(9 6)">
          <path d="M14 11.667H0L7 20z" fill="#222222" id="Path" opacity=".5" />
          <path d="M14 8.333H0L7 0z" fill="#222222" id="Path" />
        </g>
      </g>
    </g>
  </>
)
